import type { Endpoint } from ".";

export const listPropertyAssets: Endpoint = {
  id: "listPropertyAssets",
  method: "GET",
  path: "/projects/{project_id}/properties/{property_id}/assets",
  summary: "List property assets",
  description: "Returns every asset for a single property.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
    {
      name: "property_id",
      in: "path",
      required: true,
      description: "UUID of the property.",
      type: "uuid",
    },
  ],
};
